import backTriangleBlue from "@/assets/back-triangle-blue.svg";
import continueTriangleOrange from "@/assets/continue-triangle-orange.svg";
import Button from "@/common/elements/Button";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { Tab } from "react-bootstrap";
import { ContentContainer, StyledTabs, TabActions } from "./styles";
import { CONSTANT } from "@/util/ant_var";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";

const getIndex = (tabs = [], toFindKey) => {
  return tabs.findIndex((tab) => tab.key === toFindKey);
};

const Tabs = forwardRef(
  (
    {
      defaultActiveTab = "",
      tabs = [],
      navControls = false,
      tabProps = {},
      contentFullWidth = false,
      activeTab: activeTabFromProps,
      onChange,
      onNextClickTrigger,
    },
    ref
  ) => {
    const [activeTab, setActiveTab] = useState(defaultActiveTab);
    const [activeTabIndex, setActiveTabIndex] = useState(
      getIndex(tabs, defaultActiveTab)
    );

    useEffect(() => {
      if (activeTabFromProps) {
        setActiveTab(activeTabFromProps);
        setActiveTabIndex(getIndex(tabs, activeTabFromProps));
      }
    }, [activeTabFromProps]);

    const canPrev = useMemo(() => {
      if (activeTabIndex <= 0) return false;
      return true;
    }, [activeTabIndex, tabs]);

    const canNext = useMemo(() => {
      if (activeTabIndex >= tabs.length - 1) return false;
      return true;
    }, [activeTabIndex, tabs]);

    const onTabChange = (key) => {
      setActiveTab(key);
      setActiveTabIndex(getIndex(tabs, key));
      onChange && onChange(key);
    };

    const onBackClick = () => {
      if (navControls && activeTabIndex > 0) {
        setActiveTabIndex((prev) => {
          const newIndex = --prev;
          setActiveTab(tabs[newIndex].key);
          return newIndex;
        });
      }
    };

    const onNextClick = () => {
      if (navControls && activeTabIndex < tabs.length - 1) {
        setActiveTabIndex((prev) => {
          const newIndex = ++prev;
          setActiveTab(tabs[newIndex].key);
          tabs[newIndex].disabled = false;
          return newIndex;
        });
      }
    };

    useImperativeHandle(ref, () => ({
      onNextClick: () => onNextClick(),
      canNext: activeTabIndex,
      onTabChange: (key) => onTabChange(key),
    }));

    return (
      <>
        <StyledTabs fill activeKey={activeTab} onSelect={onTabChange}>
          {tabs.map(
            ({ key, title, component: Component, disabled, ref: formRef }) => (
              <Tab key={key} eventKey={key} title={title} disabled={disabled}>
                {navControls && (
                  <TabActions>
                    <Button
                      className="icon-size-xx-lg 1"
                      type="text"
                      variant="text"
                      disabled={!canPrev}
                      onClick={onBackClick}
                      icon={<CaretLeftOutlined />}
                    >
                      {/* <img alt='Back Icon' src={backTriangleBlue} /> */}
                      Back
                    </Button>

                    <Button
                      className="icon-size-xx-lg action-btn-accent"
                      style={{ color: canNext ? CONSTANT.WARNING : "" }}
                      type="link"
                      variant="link"
                      disabled={!canNext}
                      onClick={() => onNextClickTrigger(formRef)}
                      icon={
                        <>
                          <CaretRightOutlined />
                          <CaretRightOutlined style={{ marginLeft: "-18px" }} />
                        </>
                      }
                      iconPosition="end"
                    >
                      Continue
                      {/* <img alt='Continue Icon' src={continueTriangleOrange} /> */}
                    </Button>
                  </TabActions>
                )}
                <ContentContainer contentFullWidth={contentFullWidth}>
                  <Component
                    {...(tabProps.hasOwnProperty(key) ? tabProps[key] : {})}
                  />
                </ContentContainer>
              </Tab>
            )
          )}
        </StyledTabs>
      </>
    );
  }
);

export default Tabs;
